module.exports = __webpack_public_path__ + "img/ico_logo_white_m.c19f559c.svg";